export default function formatDuration(ms) {
    if (ms == null) return null;
    if (ms < 1000) return `${ms} ms`;
    const totalSeconds = ms / 1000;
    if (totalSeconds < 60) return `${totalSeconds.toFixed(1).replace('.', ',')} s`;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = Math.round(totalSeconds % 60);
    return `${minutes} min ${String(seconds).padStart(2, '0')}`;
}
